import { Component } from 'react';
import { HexAlphaColorPicker, HexColorInput } from 'react-colorful';
import getCheckboxField from '../../fields/checkbox';
import getSelectField from '../../fields/select';
import getFonts from '../../../Functions/config/fonts';
import { Accordion, AccordionItem, AccordionItemButton, AccordionItemHeading, AccordionItemPanel } from 'react-accessible-accordion';

class YelpHeader extends Component {
  constructor(props) {
    super(props);
  }

  setColorsAndPreview = async (type, color) => {
    const { setColorsAndPreview } = this.props;
    await setColorsAndPreview('header', type, color);
  };

  setHeaderColor = async (color) => {
    await this.setColorsAndPreview('headerColor', color);
  };

  setHeaderBg = async (color) => {
    await this.setColorsAndPreview('headerBgColor', color);
  };

  setReviewButtonTextColor = async (color) => {
    await this.setColorsAndPreview('reviewButtonTextColor', color);
  };

  setReviewButtonBgColor = async (color) => {
    await this.setColorsAndPreview('reviewButtonBgColor', color);
  };

  setReviewButtonHoverColor = async (color) => {
    await this.setColorsAndPreview('reviewButtonHoverColor', color);
  };
  setReviewButtonHoverBgColor = async (color) => {
    await this.setColorsAndPreview(`reviewButtonHoverBgColor`, color)
  }

  render() {
    const { widget, handleInputChange, toggleColorPicker } = this.props;
    const { yelp } = widget.htmlData;

    const fontOptions = getFonts();

    return (


      <div className="mjwi-acc-panel-wrapper">
        <div className="mjwi-yelp-display-filters">
          <div className="mjwi-row">
            <div className="mjwi-col50 ">
              <label>
                {getCheckboxField('headerStatus', yelp.header.headerStatus, handleInputChange)}
                Header
              </label>
            </div>
            {yelp.header.headerStatus === 'on' && (
              <>
                <div className="mjwi-col50 ">
                  <label>
                    {getCheckboxField('logoStatus', yelp.header.logoStatus, handleInputChange)}
                    Logo
                  </label>
                </div>
                <div className="mjwi-col50">
                  <label>
                    {getCheckboxField('companyNameStatus', yelp.header.companyNameStatus, handleInputChange)}
                    Name
                  </label>
                </div>


              </>
            )}
          </div>
        </div>
        {yelp.header.headerStatus === 'on' && (
          <>

            {
              yelp.header.companyNameStatus === 'on' && (
                <>
                  <div className="mjwi-row">
                    <div className="mjwi-col33">
                      <label>Font Family</label>
                    </div>
                    <div className="mjwi-col66">
                      {getSelectField('headerFontFamily', fontOptions, yelp.header.headerFontFamily, handleInputChange)}
                    </div>
                  </div>

                  <div className="mjwi-row">
                    <div className="mjwi-col33 mjwi-row">
                      <label htmlFor="headerFontSize">Size</label>
                      <input
                        type="number"
                        name="headerFontSize"
                        value={yelp.header.headerFontSize}
                        onChange={handleInputChange}
                      /> px
                    </div>
                    <div className="mjwi-col25">
                      <label>
                        {getCheckboxField('headerFontBold', yelp.header.headerFontBold, handleInputChange)}
                        Bold
                      </label>
                    </div>
                    <div className="mjwi-col25">
                      <label>
                        {getCheckboxField('headerFontItalic', yelp.header.headerFontItalic, handleInputChange)}
                        Italic
                      </label>
                    </div>
                  </div>

                  <div className="mjwi-row">
                    <div className="mjwi-col33">
                      <label>Color</label>
                    </div>
                    <div className="mjwi-col66 mjwi-clr-picker">
                      <span
                        className="clrPickerVal"
                        onClick={toggleColorPicker}
                        style={{ backgroundColor: yelp.header.headerColor }}
                      ></span>
                      <HexAlphaColorPicker
                        color={yelp.header.headerColor}
                        onChange={this.setHeaderColor}
                        style={{ display: 'none' }}
                        className="mjwi-apfl-color-picker"
                      />
                      <HexColorInput
                        color={yelp.header.headerColor}
                        onChange={this.setHeaderColor}
                      />
                    </div>
                  </div>

                  <div className="mjwi-row">
                    <div className="mjwi-col33">
                      <label>Background</label>
                    </div>
                    <div className="mjwi-col66 mjwi-clr-picker">
                      <span
                        className="clrPickerVal"
                        onClick={toggleColorPicker}
                        style={{ backgroundColor: yelp.header.headerBgColor }}
                      ></span>
                      <HexAlphaColorPicker
                        color={yelp.header.headerBgColor}
                        onChange={this.setHeaderBg}
                        style={{ display: 'none' }}
                        className="mjwi-apfl-color-picker"
                      />
                      <HexColorInput
                        color={yelp.header.headerBgColor}
                        onChange={this.setHeaderBg}
                      />
                    </div>
                  </div>
                </>
              )
            }




            < Accordion allowZeroExpanded={true}>
              <AccordionItem className="mjwi-sub-accordion">
                <AccordionItemHeading>
                  <AccordionItemButton>Review Count</AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemPanel>
                  <div className="mjwi-acc-panel-wrapper">
                    <div className="mjwi-row">
                      <div className="mjwi-col25">
                        <label>
                          {getCheckboxField('reviewCountStatus', yelp.header.reviewCountStatus, handleInputChange)}
                          Show
                        </label>
                      </div>
                      <div className="mjwi-col75">
                        {yelp.header.reviewCountStatus === 'on' && (
                          <div className="mjwi-row">
                            <div className="mjwi-col50 mjwi-row">
                              <label>Size</label>
                              <input
                                type="number"
                                name="reviewCountFontSize"
                                value={yelp.header.reviewCountFontSize || ''}
                                onChange={handleInputChange}
                              /> px
                            </div>
                            <div className="mjwi-col33">
                              <label>
                                {getCheckboxField('reviewCountFontBold', yelp.header.reviewCountFontBold, handleInputChange)}
                                Bold
                              </label>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>

                    {yelp.header.reviewCountStatus === 'on' && (
                      <>
                        <div className="mjwi-row">
                          <div className="mjwi-col50">
                            <label>Color</label>
                          </div>
                          <div className="mjwi-col50 mjwi-clr-picker">
                            <span
                              className="clrPickerVal"
                              onClick={toggleColorPicker}
                              style={{ backgroundColor: yelp.header.reviewCountColor }}
                            ></span>
                            <HexAlphaColorPicker
                              color={yelp.header.reviewCountColor}
                              onChange={(color) => this.setColorsAndPreview('reviewCountColor', color)}
                              style={{ display: 'none' }}
                              className="mjwi-apfl-color-picker"
                            />
                            <HexColorInput
                              color={yelp.header.reviewCountColor}
                              onChange={(color) => this.setColorsAndPreview('reviewCountColor', color)}
                            />
                          </div>
                        </div>
                        <div className="mjwi-row">
                          <div className="mjwi-col33">
                            <label>Font Family</label>
                          </div>
                          <div className="mjwi-col66">
                            {getSelectField('reviewCountFontFamily', fontOptions, yelp.header.reviewCountFontFamily, handleInputChange)}
                          </div>
                        </div>
                      </>
                    )}
                  </div>
                </AccordionItemPanel>
              </AccordionItem>
            </Accordion>



            <Accordion allowZeroExpanded={true}>
              <AccordionItem className="mjwi-sub-accordion">
                <AccordionItemHeading>
                  <AccordionItemButton>Add Review Button</AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemPanel>
                  <div className="mjwi-acc-panel-wrapper">
                    <div className="mjwi-row">
                      <div className="mjwi-col50">
                        <label>
                          {getCheckboxField('addReviewStatus', yelp.header.addReviewStatus, handleInputChange)}
                          Show
                        </label>
                      </div>
                      <div className="mjwi-col50">
                        {yelp.header.addReviewStatus === 'on' && (
                          <div className="mjwi-row">
                            <div className="mjwi-col50">
                              <label>Size</label>
                            </div>
                            <div className="mjwi-col75 mjwi-row">
                              <input
                                type="number"
                                name="reviewButtonFontSize"
                                value={yelp.header.reviewButtonFontSize || ''}
                                onChange={handleInputChange}
                              /> px
                            </div>
                          </div>
                        )}
                      </div>
                    </div>

                    {yelp.header.addReviewStatus === 'on' && (
                      <>
                        <div className="mjwi-row">
                          <div className="mjwi-col50">
                            <label>Text</label>
                          </div>
                          <div className="mjwi-col50 mjwi-clr-picker">
                            <span
                              className="clrPickerVal"
                              onClick={toggleColorPicker}
                              style={{ backgroundColor: yelp.header.reviewButtonTextColor }}
                            ></span>
                            <HexAlphaColorPicker
                              color={yelp.header.reviewButtonTextColor}
                              onChange={this.setReviewButtonTextColor}
                              style={{ display: 'none' }}
                              className="mjwi-apfl-color-picker"
                            />
                            <HexColorInput
                              color={yelp.header.reviewButtonTextColor}
                              onChange={this.setReviewButtonTextColor}
                            />
                          </div>
                        </div>
                        <div className="mjwi-row">
                          <div className="mjwi-col50">
                            <label>Background</label>
                          </div>
                          <div className="mjwi-col50 mjwi-clr-picker">
                            <span
                              className="clrPickerVal"
                              onClick={toggleColorPicker}
                              style={{ backgroundColor: yelp.header.reviewButtonBgColor }}
                            ></span>
                            <HexAlphaColorPicker
                              color={yelp.header.reviewButtonBgColor}
                              onChange={this.setReviewButtonBgColor}
                              style={{ display: 'none' }}
                              className="mjwi-apfl-color-picker"
                            />
                            <HexColorInput
                              color={yelp.header.reviewButtonBgColor}
                              onChange={this.setReviewButtonBgColor}
                            />
                          </div>
                        </div>
                        <div className="mjwi-row">
                          <div className="mjwi-col50">
                            <label>Hover Text</label>
                          </div>
                          <div className="mjwi-col50 mjwi-clr-picker">
                            <span
                              className="clrPickerVal"
                              onClick={toggleColorPicker}
                              style={{ backgroundColor: yelp.header.reviewButtonHoverColor }}
                            ></span>
                            <HexAlphaColorPicker
                              color={yelp.header.reviewButtonHoverColor}
                              onChange={this.setReviewButtonHoverColor}
                              style={{ display: 'none' }}
                              className="mjwi-apfl-color-picker"
                            />
                            <HexColorInput
                              color={yelp.header.reviewButtonHoverColor}
                              onChange={this.setReviewButtonHoverColor}
                            />
                          </div>
                        </div>
                        <div className="mjwi-row">
                          <div className="mjwi-col50">
                            <label>Hover Background</label>
                          </div>
                          <div className="mjwi-col50 mjwi-clr-picker">
                            <span
                              className="clrPickerVal"
                              onClick={toggleColorPicker}
                              style={{ backgroundColor: yelp.header.reviewButtonHoverBgColor }}
                            ></span>
                            <HexAlphaColorPicker
                              color={yelp.header.reviewButtonHoverBgColor}
                              onChange={this.setReviewButtonHoverBgColor}
                              style={{ display: 'none' }}
                              className="mjwi-apfl-color-picker"
                            />
                            <HexColorInput
                              color={yelp.header.reviewButtonHoverBgColor}
                              onChange={this.setReviewButtonBgHoverColor}
                            />
                          </div>
                        </div>
                        <div className="mjwi-row">
                          <div className="mjwi-col33">
                            <label>Font Family</label>
                          </div>
                          <div className="mjwi-col66">
                            {getSelectField('reviewButtonFontFamily', fontOptions, yelp.header.reviewButtonFontFamily, handleInputChange)}
                          </div>
                        </div>
                      </>
                    )}
                  </div>
                </AccordionItemPanel>
              </AccordionItem>
            </Accordion>

          </>

        )
        }
      </div>
    );
  }
}

export default YelpHeader;